'use strict'
const crossChainDispatcherAbi = require('./CrossChainDispatcher.json')
const debtTokenAbi = require('./DebtToken.json')
const depositTokenAbi = require('./DepositToken.json')
const feeProviderAbi = require('./FeeProvider.json')
const nativeTokenGatewayAbi = require('./NativeTokenGateway.json')
const poolAbi = require('./Pool.json')
const poolRegistryAbi = require('./PoolRegistry.json')
const quoterAbi = require('./Quoter.json')
const smartFarmingManagerAbi = require('./SmartFarmingManager.json')
const syntheticTokenAbi = require('./SyntheticToken.json')

module.exports = {
  crossChainDispatcherAbi,
  debtTokenAbi,
  depositTokenAbi,
  feeProviderAbi,
  nativeTokenGatewayAbi,
  poolAbi,
  poolRegistryAbi,
  quoterAbi,
  smartFarmingManagerAbi,
  syntheticTokenAbi
}
